// extracted by mini-css-extract-plugin
export var disablePaddingBottom = "Layout-module--disablePaddingBottom--85d34";
export var main = "Layout-module--main--376cd";